export default "__VITE_ASSET__CIVNdqwv__"